import { JSX } from 'react';
import { CtaContentCards } from '@ahc-digital/component-library';
import { CreateCTAContentCardsModel } from './C20CTAContentCards.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C20CTAContentCardsProps } from './C20CTAContentCards.types';

const Default = (props?: C20CTAContentCardsProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <CtaContentCards
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...CreateCTAContentCardsModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C20CTAContentCardsProps>(Default);
